export var CREHANA_DOMAIN = 'www.crehana.com';
export var CREHANA_ROOT_URL = 'https://www.crehana.com';
export var LOGOUT_URL = '/logout/';